import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class PlanIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <title>Plan</title>
        <path fillRule="nonzero"
          fill={this.props.active ? '#ffffff' : '#979797'}
          d="M21.31.684c.94.94.898 2.418.006
          3.31l-1.658 1.658-3.31-3.31L18.006.684a2.337
          2.337 0 0 1 3.304 0zM13.84 2.91l7.696 7.695-7.19
          7.19-1.37-1.373 5.817-5.817L17.72 9.53 6.562
          20.687 0 22l1.313-6.562L13.84 2.91z" />
      </svg>
    );
  }
}

PlanIcon.propTypes = {
  active: PropTypes.bool
};
